import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { DpFichaConsultaResultado, DpPdfArquivoEnvio, ImportDpLoteResult } from './dp-fichas.models';

@Injectable({ providedIn: 'root' })
export class DpFichasService {
  private readonly serviceApi = environment.apiUrl;

  constructor(private readonly http: HttpClient) {}

  importarPdfs(arquivos: DpPdfArquivoEnvio[]): Observable<ImportDpLoteResult> {
    const formData = new FormData();
    for (const arquivo of arquivos) {
      formData.append('pdfs', arquivo.file, arquivo.nome);
    }

    return this.http.post<ImportDpLoteResult>(
      `${this.serviceApi}/v1/dp/import-pdfs`,
      formData
    );
  }

  obterResultado(requestId: string): Observable<DpFichaConsultaResultado> {
    return this.http.get<DpFichaConsultaResultado>(
      `${this.serviceApi}/v1/dp/import-resultado/${requestId}`
    );
  }
}
